export default "__VITE_ASSET__v61ejYrM__"